import styled, { css, keyframes } from 'styled-components';

import { green } from 'utils/style/colors';

const spin = keyframes`
  to { -webkit-transform: rotate(360deg); }
`;

const animationRule = css`
  ${spin} 0.7s ease-in-out infinite;
`;

const Spinner = styled('div')`
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid rgba(127, 212, 167, 0.3);
  border-radius: 50%;
  border-top-color: ${green};
  animation: ${animationRule};
  margin: 2rem auto;
`;

export default Spinner;
